export type EnvironmentName = 'prod' | 'sandbox' | 'staging' | 'staging-sandbox' | 'dev'

export function getCurrentEnvironmentName(): EnvironmentName {
  switch (window.location.hostname) {
    case 'app.spark.ai':
      return 'prod'
    case 'sandbox.spark.ai':
      return 'sandbox'
    case 'staging.spark.ai':
      return 'staging'
    case 'staging-sandbox.spark.ai':
      return 'staging-sandbox'
    default:
      return 'dev'
  }
}
